export class Address {
    line1: string;
    line2: string;
    city: string;
    state: string;
    country: string;
    pinCode: string;
    zipplus4: string;
    constructor(obj?: any) {

        if (!obj) {
            return;
        }
        this.line1 = obj.line1;
        this.line2 = obj.line2;
        this.city = obj.city;
        this.state = obj.state;
        this.country = obj.country;
        this.pinCode = obj.pinCode;
        this.zipplus4 = obj.zipplus4;
    }
}
